/**
 * Wally PDP Tracker
 * Tracks product detail page views and add-to-cart events,
 * with collection referrer context from query params.
 *
 * Reads ?ref=collection-handle&pos=N from the URL (set by collection-tracker.js).
 *
 * Required data attribute on product page:
 *   data-product-id="123456789"  (Shopify numeric product ID, on body, main product section, or form)
 *
 * Config (set before this script loads):
 *   window.__wallyTrackingUrl = 'https://your-worker.workers.dev';
 */

(function () {
  'use strict';

  var WORKER_URL = window.__wallyTrackingUrl;
  if (!WORKER_URL) return;

  var ENDPOINT = WORKER_URL + '/events';

  // Get product ID from the page
  var productEl = document.querySelector('[data-product-id]');
  if (!productEl) return;
  var productId = productEl.getAttribute('data-product-id');
  if (!productId) return;

  // Get collection referrer context from query params
  var params = new URLSearchParams(window.location.search);
  var refCollection = params.get('ref');
  var refPosition = params.get('pos');

  // Session ID (same as collection tracker)
  var sessionId = sessionStorage.getItem('wally_sid');
  if (!sessionId) {
    sessionId = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2);
    sessionStorage.setItem('wally_sid', sessionId);
  }

  var eventQueue = [];

  function queueEvent(type) {
    eventQueue.push({
      type: type,
      product_id: productId,
      collection: refCollection || 'direct',
      position: refPosition ? parseInt(refPosition, 10) : null,
      timestamp: Math.floor(Date.now() / 1000),
    });
  }

  function flush() {
    if (eventQueue.length === 0) return;

    var payload = JSON.stringify({
      events: eventQueue.splice(0),
      session_id: sessionId,
      page_url: location.pathname,
    });

    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(ENDPOINT, {
        method: 'POST',
        body: payload,
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
      }).catch(function () {});
    }
  }

  // --- PDP view event ---

  queueEvent('pdp_view');

  // Fire GA4 view_item with collection context
  if (typeof gtag === 'function' && refCollection) {
    gtag('event', 'view_item', {
      item_list_name: refCollection,
      item_list_id: refCollection,
      items: [{
        item_id: productId,
        index: refPosition ? parseInt(refPosition, 10) : undefined,
        item_list_name: refCollection,
      }],
    });
  }

  // --- Add to cart tracking ---

  // Listen for Shopify's native form submit and AJAX add-to-cart
  var addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  for (var i = 0; i < addToCartForms.length; i++) {
    addToCartForms[i].addEventListener('submit', function () {
      queueEvent('atc');
      flush();
    });
  }

  // Also intercept fetch-based add to cart (common in modern themes)
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var url = arguments[0];
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        queueEvent('atc');
        flush();
      }
      return originalFetch.apply(this, arguments);
    };
  }

  // --- Clean up referrer params from URL (cosmetic) ---

  if (refCollection && window.history && window.history.replaceState) {
    params.delete('ref');
    params.delete('pos');
    var cleanUrl = window.location.pathname;
    var remaining = params.toString();
    if (remaining) cleanUrl += '?' + remaining;
    window.history.replaceState(null, '', cleanUrl);
  }

  // --- Flush on page hide ---

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);

  // Flush after short delay in case user bounces quickly
  setTimeout(flush, 5000);
})();
